import { call } from '@advanza/api'
import { QuestionAnswer } from '@trustoo/types/entity/anonymizedRequest'
import { _changeFilter, _fetchItems } from 'actions/lists'
import { AppThunkAction } from 'hooks/hooks'
import anonymizedRequestsSchema from 'schemes/anonymizedRequestsSchema'

export function fetchAnonymizedRequests(filterId: string) {
    return _fetchItems(filterId, {
        url: 'office/anonymized-requests/get-list',
        schema: anonymizedRequestsSchema,
        reducerKey: 'anonymizedRequests',
    })
}

// Options handled by the back-end
export interface AnonymizedRequestsFilterOptions {
    pageNr?: number
    pageSize?: number
    serviceIds?: number[]
    query?: string
    startDate?: string | null
    endDate?: string | null

    // common
    page?: number
    countList?: boolean
    didInvalidate?: boolean
    pageSize_?: number
}

export function changeAnonymizedRequestsFilter(
    filterId: string,
    options: AnonymizedRequestsFilterOptions,
) {
    return _changeFilter(filterId, options, {
        reducerKey: 'anonymizedRequests',
        fetchFunc: fetchAnonymizedRequests,
    })
}

interface SaveAnonymizedRequestPayload {
    details: string
    questions_answers: QuestionAnswer[]
}

export function saveAnonymizedRequest(
    anonymizedRequestId: number,
    payload: SaveAnonymizedRequestPayload,
): AppThunkAction<Promise<void>> {
    return async (dispatch) => {
        await call(`office/anonymized-requests/save/${anonymizedRequestId}`, {
            json: payload,
        })
        dispatch({ type: 'INVALIDATE_ANONYMIZEDREQUESTS' })
    }
}

export function deleteAnonymizedRequest(
    anonymizedRequestId: number,
): AppThunkAction<Promise<void>> {
    return async (dispatch) => {
        await call(`office/anonymized-requests/delete/${anonymizedRequestId}`, {
            method: 'post',
        })
        dispatch({ type: 'INVALIDATE_ANONYMIZEDREQUESTS' })
    }
}
